/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function DefaultIlkIcon({
  width = 50,
  height = 50,
  fill = 'white',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <circle cx={15} cy={15} r={12} fill="#D1EEEB" />
      <path
        d="M11 11.81a.345.345 0 00.211.333.34.34 0 00.136.026h1.187c.198 0 .356-.164.382-.363.13-.95.777-1.642 1.93-1.642.987 0 1.89.497 1.89 1.692 0 .92-.538 1.342-1.388 1.985-.968.709-1.734 1.536-1.68 2.878l.005.314a.363.363 0 00.36.357h1.166a.358.358 0 00.36-.362v-.152c0-1.04.392-1.343 1.452-2.153.876-.67 1.789-1.415 1.789-2.977 0-2.189-1.835-3.246-3.845-3.246-1.822 0-3.818.854-3.955 3.31zm2.24 8.347c0 .772.61 1.343 1.452 1.343.876 0 1.479-.57 1.479-1.343 0-.799-.604-1.361-1.48-1.361-.84 0-1.451.562-1.451 1.361z"
        fill="#2FB3A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.258 6.304a8.817 8.817 0 00-3.175 1.316 2.245 2.245 0 013.174-1.315zm.024-.004a8.91 8.91 0 013.436 0 2.246 2.246 0 00-3.436 0zm3.437 0a8.815 8.815 0 013.125 1.272 2.23 2.23 0 00-.534-.85 2.245 2.245 0 00-2.59-.422zm3.197 1.32a8.916 8.916 0 012.401 2.372 2.266 2.266 0 00-.167-.99 2.245 2.245 0 00-2.234-1.382zm2.462 2.463a8.814 8.814 0 011.317 3.176 2.245 2.245 0 00-1.317-3.177zM23.7 13.28c.109.556.166 1.131.166 1.719a8.825 8.825 0 01-1.439 4.844 2.247 2.247 0 001.273-3.126 2.247 2.247 0 000-3.437zm-1.32 6.635a8.917 8.917 0 01-2.371 2.401 2.251 2.251 0 001.718-.654 2.246 2.246 0 00.653-1.747zm-2.397 2.418a8.818 8.818 0 01-3.164 1.346 2.246 2.246 0 003.164-1.346zm-3.187 1.35a8.904 8.904 0 01-3.437.031 2.246 2.246 0 003.437-.03zm-3.515.016a8.815 8.815 0 01-3.124-1.27 2.258 2.258 0 00.533.848 2.245 2.245 0 002.59.422zm-3.198-1.32a8.916 8.916 0 01-2.4-2.37 2.25 2.25 0 001.383 2.204 2.246 2.246 0 001.017.166zm-2.42-2.397A8.819 8.819 0 016.32 16.82a2.245 2.245 0 001.344 3.162zm-1.349-3.188a8.906 8.906 0 01-.03-3.435 2.246 2.246 0 00.03 3.435zM6.3 13.279a8.815 8.815 0 011.272-3.122 2.248 2.248 0 00-1.507 2.121A2.245 2.245 0 006.3 13.28zm1.321-3.197a8.916 8.916 0 012.37-2.4 2.247 2.247 0 00-2.37 2.4z"
        fill="#2FB3A4"
      />
      <circle cx={15} cy={15} r={10.15} stroke="#2FB3A4" strokeWidth={0.2} />
    </svg>
  );
}

const MemoDefaultIlkIcon = React.memo(DefaultIlkIcon);
export default MemoDefaultIlkIcon;
